import React, {Component} from 'react';
import SweetAlert from 'sweetalert2-react';
import Swal from 'sweetalert2'
import i18n from '../../i18n';

const errorTitle = i18n.t("Σφάλμα");
const warningTitle = i18n.t("Προσοχή");
const infoTitle = i18n.t("Ενμέρωση");

const okCaption = i18n.t("OK");

const animation = true;


class Dialog extends Component {

    render() {

        var type = this.props.type? this.props.type.toLowerCase(): "info";
        var title;
        var message;
        var showCancel = false;
        var cancelText = null;

        if (this.props.message)
            message = this.props.message;
        else if (this.props.errorMessage)
        {
            message = this.props.errorMessage;
            type = "error";
        }
        else if (this.props.warningMessage)
        {
            message = this.props.warningMessage;
            type = "warning";
        }
        else if (this.props.questionMessage) {
            showCancel = true;
            cancelText = i18n.t("Άκυρο")
        }

        if (this.props.type === "question") {
            showCancel = true;
        }

        if (this.props.title)
            title = this.props.title;
        else {
            if (type === "error")
                title = errorTitle;
            else if (type === "warning")
                title = warningTitle;
            else if (type === "info")
                title = infoTitle;
        }

        if (!message)
            return null;

        return (
            <SweetAlert
                show={message}
                title={title}
                text={message}
                type={type}
                showCancelButton = {showCancel}
                cancelButtonText = {cancelText}
                onConfirm={this.props.onConfirm}
                animation={animation} />
        );
    }

    static async displayInfo({message, title, callback, buttonText}) {

        await Swal.fire({
            title: title,
            text: message,
            type: "info",
            confirmButtonText: buttonText? buttonText : okCaption,
            animation: animation,
            allowOutsideClick: true
        });

        if (callback) {
            callback();
        }
    }

    static async displayConfirmation({message, title, callback}) {
        
        await Swal.fire({
            title: title,
            text: message,
            type: "success",
            confirmButtonText: okCaption,
            animation: animation,
            allowOutsideClick: true
        });

        if (callback) {
            callback();
        }
    }

    static async displayYesNoQuestion({message, title, confirmCallback, cancelCallback, confirmButtonText, cancelButtonText}) {

        if (!confirmButtonText)
            confirmButtonText = i18n.t("Ναι");

        if (!cancelButtonText)
            cancelButtonText = i18n.t("Άκυρο");

        var result = await Swal.fire({
            title: title,
            text: message,
            type: "question",
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            showCancelButton: true,
            animation: animation,
            allowOutsideClick: false
        });


        if (result.value === true && confirmCallback) {
            confirmCallback();
        }
        else if (cancelCallback) {
            cancelCallback();
        }
        
        return result? result.value === true : false;
    }

    static async displayWarning(message, title, callback) {
        if (!title)
            title = warningTitle;
        
        await Swal.fire({
            title: title,
            text: message,
            type: "warning",
            confirmButtonText: okCaption,
            animation: animation,
            allowOutsideClick: true
        })

        if (callback) {
            callback();
        }
    }

    static async displayError(errorMessage, title, callback) {
        
        if (!title)
            title = errorTitle;

        await Swal.fire({
            title: title,
            text: errorMessage,
            type: "error",
            confirmButtonText: okCaption,
            animation: animation,
            allowOutsideClick: true
        });

        if (callback) {
            callback();
        } 
    }

    /**
     *  Displays a toast notification message
     */
    static async displayToast({message, duration, type, position, content}) {
        
        if (duration === undefined)
            duration = 3000;
        
        if (!position)
            position = "top-end";
        
        await Swal.fire({
            position: position,
            toast: true,
            type: type,
            html: content,
            text: message,
            showConfirmButton: false,
            timer: duration
          })
    }

    /**
     * Hides any toast messages that happen to be visible
     */
    static async hideToast() {
        Swal.fire({
            toast: true,
            html: "<div/>",
            timer: 1
        })
    }
}

export default Dialog;